import { render, staticRenderFns } from "./Templates.vue?vue&type=template&id=a8d08df0&scoped=true"
import script from "./Templates.vue?vue&type=script&lang=ts"
export * from "./Templates.vue?vue&type=script&lang=ts"
import style0 from "./Templates.vue?vue&type=style&index=0&id=a8d08df0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d08df0",
  null
  
)

export default component.exports